import { render, staticRenderFns } from "./TransferComponent.vue?vue&type=template&id=2722a418"
import script from "./TransferComponent.vue?vue&type=script&lang=js"
export * from "./TransferComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports